// Where the app is running: chessbut.app in a browser, or inside the iOS/Android app
// (Capacitor), which loads the same build from the device and talks to chessbut.app.

/** Built for the native app (`pnpm --filter @chessbut/web build:app`). */
export const NATIVE = import.meta.env.VITE_NATIVE === '1';

/** The public site: share links, and the API/socket when running in the app. */
export const SITE_URL: string = NATIVE ? (import.meta.env.VITE_SITE_URL ?? 'https://chessbut.app') : location.origin;

/** Prefix for API paths ('' on the website, which serves the API itself). */
export const API_BASE = NATIVE ? SITE_URL : '';

export function socketUrl(): string {
  if (NATIVE) return `${SITE_URL.replace(/^http/, 'ws')}/ws`;
  return `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`;
}
